import React from "react";

import { displayError } from "../../../helpers";
import { CheckboxWithLabel, SwitchWithLabel, Textfield } from "../../../components";
import { useSelector } from "react-redux";

export default function CorporateMatch({ handleChange, validationErrors }) {
    const state = useSelector(state => state.donationCheckout);

    const assignClasses = state.doubleTheImpact ? "cm-box-outer yellow" : "cm-box-outer"

    return <div className={assignClasses} id="corporateMatchSection">
        <div className="">
            <CheckboxWithLabel label="Double the impact of your gift" nameAndId="doubleTheImpact" handleCheck={handleChange} />
            {state.doubleTheImpact &&
                <div id="corporate_match_div">
                    <div className='row'>
                        <div className="col">
                            <div className="checkoutforms-group">
                                <Textfield
                                    id="corporateMatchEmployer"
                                    name="corporateMatchEmployer"
                                    label="Employer's Name *"
                                    value={state.corporateMatchEmployer}
                                    error={displayError(validationErrors?.corporateMatch)}
                                    helperText={validationErrors?.corporateMatch}
                                    onChange={handleChange}
                                    sx={{
                                        '& .MuiOutlinedInput-root, .Mui-focused': {
                                            borderRadius: '8px',
                                        },
                                    }}
                                    fullWidth
                                />
                            </div>
                        </div>
                    </div>
                    <CheckboxWithLabel label="Contact me for corporate matching" nameAndId="contactMeForCorporateMatch" handleCheck={handleChange}/>
                </div>}
        </div>
    </div>
}